import './index.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import OffersToast from '../offers-toast';
import copyCodeImage from '../../../assets/images/offers/copy-code.svg';
import { getCategoryImage } from '../../utils/services';
///
class OffersVoucherCode extends Component {
  constructor() {
    super();
    this.state = {
      toastMessage: ''
    };
  }

  codeClick = () => {
    const copyText = document.getElementById('code');
    const textArea = document.createElement('textarea');
    textArea.value = copyText.textContent;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    this.setState({ toastMessage: 'Code copied to clipboard' });
  };

  toastDestroyHandler = () => {
    const { closeOnClick } = this.props;
    this.setState({ toastMessage: '' });
    closeOnClick();
  };

  render() {
    const {
      theme,
      // termsAndConditionClick,
      couponCode,
      // isVoucherCard,
      data,
      onClickButton,
      vouchersPageHandler
    } = this.props;
    const {
      is_product,
      description,
      title,
      image_url,
      product,
      is_show_on_list,
      deeplink_type,
      is_from_offer,
      offer_type,
      is_redemed
    } = data;
    const imageUrl =
      product && product[0]
        ? getCategoryImage(product[0].image_urls, 'offer')
        : image_url;
    const { toastMessage } = this.state;
    return (
      <div className="voucher-code_wrapper">
        <div className="voucher-code">
          <div className="voucher-code__image">
            {imageUrl && imageUrl['1x'] ? (
              <picture>
                <source
                  srcSet={`${imageUrl['1x']}, ${imageUrl['2x']} 2x, ${imageUrl['3x']} 3x`}
                  type="image/jpeg/png"
                />
                <img
                  src={`${imageUrl['2x']}`}
                  alt={title}
                  className="voucher-code__img"
                />
              </picture>
            ) : (
              <img src={image_url} alt={title} className="voucher-code__img" />
            )}
          </div>

          <div className="voucher-code__details">
            {(is_show_on_list === false &&
              product?.length > 0 &&
              deeplink_type === 'OFFER' &&
              is_from_offer === true) ||
            (offer_type?.toLowerCase() === 'product' && is_redemed === true) ? (
              <>
                <p className="voucher-code__title">{product?.[0]?.name}</p>
                <p className="voucher-code__description">
                  {product?.[0]?.description}
                </p>
              </>
            ) : is_show_on_list === true ||
              deeplink_type === 'OFFER' ||
              offer_type === 'DISCOUNT' ||
              is_redemed === false ||
              offer_type?.toLowerCase() === 'product' ? (
              <>
                <p className="voucher-code__title">{title}</p>
                <p className="voucher-code__description">{description}</p>
              </>
            ) : null}
            <div className="voucher-code__timer">
              {/* <OfferTimer
                content="Expires on 23 feb 2019"
                customClassView="modal-list"
              /> */}
            </div>
            {is_product ? (
              <Button
                theme={theme}
                content="add item to cart"
                type="block"
                size="is-large"
                onClick={() => onClickButton(true, data)}
              />
            ) : (
              <div className="voucher-code__copy-code">
                <p className="voucher-code__code" id="code">
                  {title}
                </p>
                <img
                  src={copyCodeImage}
                  alt="copy code"
                  className="voucher-code__copy-img u_cursor_pointer"
                  onClick={() => this.codeClick()}
                  role="presentation"
                />
              </div>
            )}

            <p className="voucher-code__voucher-msg">
              You can always find this voucher in
              <span
                className="voucher-code__voucher-msg_bold u_cursor_pointer"
                onClick={() => vouchersPageHandler()}
                role="presentation"
              >
                {' '}
                Saved King Deals
              </span>
            </p>
          </div>
        </div>
        {toastMessage ? (
          <OffersToast
            content={toastMessage}
            destroyHanlder={this.toastDestroyHandler}
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

OffersVoucherCode.propTypes = {
  theme: PropTypes.string
};

OffersVoucherCode.defaultProps = {
  theme: ''
};

export default OffersVoucherCode;
